import {
	Button, SubmitButton, ResetButton,
} from './buttons';
import {
	Checkbox,
	CheckboxGroup,
	PasswordInput,
	RadioGroup,
	TextAreaInput,
	TextInput,
	SelectInput,
	SwitchInput,
	PhoneInput,
	DateInput,
	NumericInput,
	StaticText,
	SelectInputGroup,
} from './inputs';
import { FormProvider } from './providers';
import { FormField } from './wrapper';

const FormButton = {
	Button:       Button,
	Reset:        ResetButton,
	SubmitButton: SubmitButton,
};

const FormInput = {
	Checkbox:         Checkbox,
	CheckboxGroup:    CheckboxGroup,
	DateInput:        DateInput,
	NumericInput:     NumericInput,
	PasswordInput:    PasswordInput,
	PhoneInput:       PhoneInput,
	RadioGroup:       RadioGroup,
	SelectInput:      SelectInput,
	SelectInputGroup: SelectInputGroup,
	StaticText:       StaticText,
	SwitchInput:      SwitchInput,
	TextAreaInput:    TextAreaInput,
	TextInput:        TextInput,
};

export const Form = {
	...FormButton,
	...FormInput,
	Field:    FormField,
	Provider: FormProvider,
};
